// extracted by mini-css-extract-plugin
export default {"timerForm":"TimerHarvestor_timerForm__MZ36n","inner":"TimerHarvestor_inner__vRk1s","spacing":"TimerHarvestor_spacing__PhkPR"};